import { useEffect, useRef } from 'react';
import { useComms } from '@/modules/comms/context/CommsContext';

interface AuthenticatedCommsStartupProps {
  callerSubject: string | null;
}

export const AuthenticatedCommsStartup = ({
  callerSubject,
}: AuthenticatedCommsStartupProps) => {
  const { ensureStarted } = useComms();
  const startedSubjectRef = useRef<string | null>(null);

  useEffect(() => {
    if (!callerSubject) {
      startedSubjectRef.current = null;
      return;
    }
    if (startedSubjectRef.current === callerSubject) return;
    startedSubjectRef.current = callerSubject;
    void ensureStarted().catch(() => undefined);
  }, [callerSubject, ensureStarted]);

  return null;
};
